import axios from 'axios'

/**
 * CSRFトークンを取得する
 */
export const fetch = async (): Promise<string> =>
  (await axios.get<{ token: string }>('/csrf/')).data.token
